import React from "react";
import { NavLink } from "react-router-dom";
import "./IdCardsAdminNav.css";

export default function IdCardsAdminNav(){
  return <nav className="id-admin-nav" aria-label="Digital ID administration">
    <NavLink end to="/id-cards">Card Registry</NavLink>
    <NavLink end to="/card-templates">Card Templates</NavLink>
    <NavLink to="/card-templates/create">Template Designer</NavLink>
  </nav>;
}
